// extracted by mini-css-extract-plugin
module.exports = {"box":"GetQuestion_box__2hMMr","fadeIn":"GetQuestion_fadeIn__w9060","input":"GetQuestion_input__1HPg-","submit":"GetQuestion_submit__2wYPs"};